/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_LeadInputs */

const en_mk_sol_konsultan_lead = /** @type {(inputs: Mk_Sol_Konsultan_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten consultants across five client engagements. What you sell is expert judgement; what costs the most is the time spent gathering material before that judgement can be made.`)
};

const id_mk_sol_konsultan_lead = /** @type {(inputs: Mk_Sol_Konsultan_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepuluh konsultan mengerjakan lima proyek klien. Yang dijual adalah penilaian ahli, dan yang paling mahal adalah waktu yang habis untuk mengumpulkan bahan sebelum penilaian itu bisa dibuat.`)
};

/**
* | output |
* | --- |
* | "Ten consultants across five client engagements. What you sell is expert judgement; what costs the most is the time spent gathering material before that judge..." |
*
* @param {Mk_Sol_Konsultan_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_lead = /** @type {((inputs?: Mk_Sol_Konsultan_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_lead(inputs)
	return en_mk_sol_konsultan_lead(inputs)
});